export const tr = {
    'archived-campaign-modification': 'Arşivlenen kampanyalara anahtar sözcük grupları eklenemez',
    'max-keywords-exceeded': 'Reklam grubu başına {maxKeywords} sözcük grubu sınırlaması aşıldı',
    'validation-error': 'Reklam grubuna anahtar sözcük grupları eklenemedi. Daha sonra tekrar deneyin'
};
